export enum EMapContent {
    DETAIL = 'detail',
    INVENTORY = 'inventory',
    INFORMATION = 'information',
}